import { createAction } from '@reduxjs/toolkit';

export const requestViewPersonDetails = createAction('party/viewPersonDetails');
export const requestViewPersonProfile = createAction('party/viewPersonProfile');
export const requestUpdatePersonDetails = createAction('party/updatePersonDetails');
export const requestUpdatePersonUsername = createAction('party/updatePersonUsername');
export const requestUpdatePersonEmail = createAction('party/updatePersonEmail');
export const requestUpdateProfilePicture = createAction('party/updateProfilePicture');
export const requestViewAllFacilitators = createAction('party/viewAllFacilitators');
export const requestSearchOrganisation = createAction('party/searchOrganisation');
export const requestResetPasswordInternal = createAction('party/resetPasswordInternal');
export const requestAddRepresentative = createAction('party/addRepresentative');
export const requestDeleteUserDetails = createAction('party/deleteUserDetails');
